!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("ati-ui-react/components/InputSubtext")) : "function" == typeof define && define.amd ? define("ati-ui-react", ["react", "ati-ui-react/components/InputSubtext"], t) : "object" == typeof exports ? exports["ati-ui-react"] = t(require("react"), require("ati-ui-react/components/InputSubtext")) : e["ati-ui-react"] = t(e.React, e[void 0]);
}(this, function (r, n) {
  return i = {}, o.m = a = {
    0: function (e, t) {
      e.exports = r;
    },
    10: function (e, t, r) {
      "use strict";

      r.d(t, "b", function () {
        return n;
      }), r.d(t, "a", function () {
        return o;
      });
      var n = function (t) {
          for (var e = arguments.length, r = Array(1 < e ? e - 1 : 0), n = 1; n < e; n++) r[n - 1] = arguments[n];
          return r.filter(Boolean).map(function (e) {
            return t[e];
          }).join(" ");
        },
        o = function () {
          for (var e = arguments.length, t = Array(e), r = 0; r < e; r++) t[r] = arguments[r];
          return t.filter(Boolean).join(" ");
        };
    },
    17: function (e, t) {
      e.exports = n;
    },
    2: function (e, t, o) {
      "use strict";

      var r,
        n,
        c = function () {
          return r = void 0 === r ? !(!(window && document && document.all) || window.atob) : r;
        },
        a = (n = {}, function (e) {
          if (void 0 === n[e]) {
            var t = document.querySelector(e);
            if (window.HTMLIFrameElement && t instanceof window.HTMLIFrameElement) try {
              t = t.contentDocument.head;
            } catch (e) {
              t = null;
            }
            n[e] = t;
          }
          return n[e];
        }),
        l = [];
      function s(e) {
        for (var t = -1, r = 0; r < l.length; r++) if (l[r].identifier === e) {
          t = r;
          break;
        }
        return t;
      }
      function u(e, t) {
        for (var r = {}, n = [], o = 0; o < e.length; o++) {
          var a = e[o],
            i = t.base ? a[0] + t.base : a[0],
            c = r[i] || 0,
            u = "".concat(i, " ").concat(c);
          r[i] = c + 1;
          c = s(u), a = {
            css: a[1],
            media: a[2],
            sourceMap: a[3]
          };
          -1 !== c ? (l[c].references++, l[c].updater(a)) : l.push({
            identifier: u,
            updater: function (t, e) {
              var r, n, o;
              {
                var a;
                o = e.singleton ? (a = h++, r = b = b || f(e), n = p.bind(null, r, a, !1), p.bind(null, r, a, !0)) : (r = f(e), n = function (e, t, r) {
                  var n = r.css,
                    o = r.media,
                    r = r.sourceMap;
                  o ? e.setAttribute("media", o) : e.removeAttribute("media");
                  r && "undefined" != typeof btoa && (n += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(r)))), " */"));
                  if (e.styleSheet) e.styleSheet.cssText = n;else {
                    for (; e.firstChild;) e.removeChild(e.firstChild);
                    e.appendChild(document.createTextNode(n));
                  }
                }.bind(null, r, e), function () {
                  !function (e) {
                    if (null === e.parentNode) return;
                    e.parentNode.removeChild(e);
                  }(r);
                });
              }
              return n(t), function (e) {
                e ? e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap || n(t = e) : o();
              };
            }(a, t),
            references: 1
          }), n.push(u);
        }
        return n;
      }
      function f(e) {
        var t,
          r = document.createElement("style"),
          n = e.attributes || {};
        if (void 0 !== n.nonce || (t = o.nc) && (n.nonce = t), Object.keys(n).forEach(function (e) {
          r.setAttribute(e, n[e]);
        }), "function" == typeof e.insert) e.insert(r);else {
          e = a(e.insert || "head");
          if (!e) throw Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
          e.appendChild(r);
        }
        return r;
      }
      var i,
        d = (i = [], function (e, t) {
          return i[e] = t, i.filter(Boolean).join("\n");
        });
      function p(e, t, r, n) {
        r = r ? "" : n.media ? "@media ".concat(n.media, " {").concat(n.css, "}") : n.css;
        e.styleSheet ? e.styleSheet.cssText = d(t, r) : (n = document.createTextNode(r), (r = e.childNodes)[t] && e.removeChild(r[t]), r.length ? e.insertBefore(n, r[t]) : e.appendChild(n));
      }
      var b = null,
        h = 0;
      e.exports = function (e, a) {
        (a = a || {}).singleton || "boolean" == typeof a.singleton || (a.singleton = c());
        var i = u(e = e || [], a);
        return function (e) {
          if ("[object Array]" === Object.prototype.toString.call(e = e || [])) {
            for (var t = 0; t < i.length; t++) {
              var r = s(i[t]);
              l[r].references--;
            }
            for (var e = u(e, a), n = 0; n < i.length; n++) {
              var o = s(i[n]);
              0 === l[o].references && (l[o].updater(), l.splice(o, 1));
            }
            i = e;
          }
        };
      };
    },
    226: function (e, t, r) {
      (t = e.exports = r(4)()).push([e.i, "._3KdNf-2-0-721{width:100%;display:flex;position:relative;font-family:Verdana,Dejavu Sans,Geneva,Tahoma,sans-serif}._28Hpe-2-0-721{position:absolute;right:8px;top:5px}._28Hpe-2-0-721 ._2vgLn-2-0-721,._28Hpe-2-0-721 ._3eE9Z-2-0-721{line-height:16px;font-size:12px}._28Hpe-2-0-721 ._2vgLn-2-0-721{color:#8c969d}._28Hpe-2-0-721 ._3eE9Z-2-0-721{color:#d0021b}._1KGab-2-0-721{width:100%;height:59px;background-color:#fff;border:1px solid #ccc;border-radius:2px;font-size:12px;line-height:15px;letter-spacing:-.1px;font-weight:400;padding:8px 7px 5px;color:#39444f;resize:none;caret-color:#8c969d;font-family:Verdana,Dejavu Sans,Geneva,Tahoma,sans-serif;-ms-overflow-style:none;scrollbar-width:none}._1KGab-2-0-721::-webkit-scrollbar{display:none}._1KGab-2-0-721::-moz-placeholder{color:#b8b8b8}._1KGab-2-0-721:-ms-input-placeholder{color:#b8b8b8}._1KGab-2-0-721::placeholder{color:#b8b8b8}._1KGab-2-0-721:focus,._1KGab-2-0-721:hover{border:1px solid #8c969d}._1KGab-2-0-721:focus{box-shadow:0 1px 2px rgba(0,0,0,.21);outline:0}._1KGab-2-0-721._2sm3l-2-0-721,._1KGab-2-0-721._2sm3l-2-0-721:focus{background-color:#f1f1f1;border:1px solid #ccc;color:#ccc;cursor:not-allowed;box-shadow:none}._1KGab-2-0-721._2sm3l-2-0-721{color:#b8b8b8}._1KGab-2-0-721._1hQof-2-0-721{background-color:#fff0f2;border:1px solid #d0021b}._1KGab-2-0-721._2CFEW-2-0-721{border-bottom-color:#dea00a;box-shadow:inset 0 -1px 0 #dea00a}._1KGab-2-0-721._2sm3l-2-0-721{background-color:#f1f1f1;border:1px solid #ccc;box-shadow:none;cursor:not-allowed}._1KGab-2-0-721._2Az8r-2-0-721{padding-right:38px}", ""]), t.locals = {
        "textarea-wrapper": "_3KdNf-2-0-721",
        "textarea-count": "_28Hpe-2-0-721",
        counter: "_2vgLn-2-0-721",
        "negative-counter": "_3eE9Z-2-0-721",
        textarea: "_1KGab-2-0-721",
        disabled: "_2sm3l-2-0-721",
        error: "_1hQof-2-0-721",
        warning: "_2CFEW-2-0-721",
        "textarea-wrapper-count": "_2Az8r-2-0-721"
      };
    },
    4: function (e, t) {
      e.exports = function () {
        var i = [];
        return i.toString = function () {
          for (var e = [], t = 0; t < this.length; t++) {
            var r = this[t];
            r[2] ? e.push("@media " + r[2] + "{" + r[1] + "}") : e.push(r[1]);
          }
          return e.join("");
        }, i.i = function (e, t) {
          "string" == typeof e && (e = [[null, e, ""]]);
          for (var r = {}, n = 0; n < this.length; n++) {
            var o = this[n][0];
            "number" == typeof o && (r[o] = !0);
          }
          for (n = 0; n < e.length; n++) {
            var a = e[n];
            "number" == typeof a[0] && r[a[0]] || (t && !a[2] ? a[2] = t : t && (a[2] = "(" + a[2] + ") and (" + t + ")"), i.push(a));
          }
        }, i;
      };
    },
    596: function (e, t, r) {
      "use strict";

      r.r(t), r.d(t, "default", function () {
        return o;
      });
      var n = r(0),
        p = r.n(n),
        b = r(10),
        t = r(17),
        h = r.n(t),
        n = r(2),
        t = r.n(n),
        n = r(226),
        r = r.n(n),
        n = {
          insert: "head",
          singleton: !1
        },
        m = (t()(r.a, n), r.a.locals || {});
      function v() {
        return (v = Object.assign || function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var r,
              n = arguments[t];
            for (r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
          return e;
        }).apply(this, arguments);
      }
      function x(e, t) {
        if (null == e) return {};
        var r,
          n = function (e, t) {
            if (null == e) return {};
            var r,
              n,
              o = {},
              a = Object.keys(e);
            for (n = 0; n < a.length; n++) r = a[n], ~t.indexOf(r) || (o[r] = e[r]);
            return o;
          }(e, t);
        if (Object.getOwnPropertySymbols) for (var o = Object.getOwnPropertySymbols(e), a = 0; a < o.length; a++) r = o[a], ~t.indexOf(r) || Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
        return n;
      }
      r = function (e) {
        var t = e.error,
          r = e.className,
          n = e.errorText,
          o = e.disabled,
          a = e.action,
          i = e.value,
          c = e.counter,
          u = e.showCounter,
          l = e.reference,
          s = e.dataQa,
          f = e.warning,
          d = e.warningText,
          e = x(e, ["error", "className", "errorText", "disabled", "action", "value", "counter", "showCounter", "reference", "dataQa", "warning", "warningText"]),
          u = u;
        return "boolean" == typeof c && (console.warn('Textarea: "counter" prop is deprecated. Please use "showCounter" prop instead.'), u = c), p.a.createElement("div", {
          className: r,
          "data-qa": s
        }, p.a.createElement("div", {
          className: m["textarea-wrapper"]
        }, p.a.createElement("textarea", v({
          onChange: a,
          className: Object(b.b)(m, "textarea", o && "disabled", t && "error", f && "warning", u && "textarea-wrapper-count"),
          value: i,
          ref: l,
          disabled: o
        }, e)), u && p.a.createElement("div", {
          className: m["textarea-count"]
        }, p.a.createElement("span", {
          className: 0 <= e.maxLength - i.length ? m.counter : m["negative-counter"]
        }, e.maxLength - i.length))), (n || d) && p.a.createElement(h.a, {
          type: n ? "error" : "warning"
        }, n || d));
      };
      r.defaultProps = {
        className: "",
        value: "",
        maxLength: 113,
        disabled: !1,
        error: !1,
        showCounter: !0,
        dataQa: "textarea"
      };
      var o = r;
    }
  }, o.c = i, o.d = function (e, t, r) {
    o.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, o.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, o.t = function (t, e) {
    if (1 & e && (t = o(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var r = Object.create(null);
    if (o.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var n in t) o.d(r, n, function (e) {
      return t[e];
    }.bind(null, n));
    return r;
  }, o.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return o.d(t, "a", t), t;
  }, o.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, o.p = "", o(o.s = 596);
  function o(e) {
    if (i[e]) return i[e].exports;
    var t = i[e] = {
      i: e,
      l: !1,
      exports: {}
    };
    return a[e].call(t.exports, t, t.exports, o), t.l = !0, t.exports;
  }
  var a, i;
});